import { instance } from "./api"
import { useAuthStore } from '../stores/t-auth';
import type { UsuarioResponse } from '../types';

async function getDatosUsuario(user_name: string) {
	const auth = useAuthStore();
	return await instance.get<UsuarioResponse>(`/security/usuario/${user_name}`, {
		headers: {
			Accept: 'application/json',
			Authorization: 'Bearer ' + auth.token
		}
	});
}
async function checkPermiso(id_permiso: string) {
    const auth = useAuthStore();
    const userParams = auth.userParams;
    if (!userParams || !userParams.Usuario || !userParams.Usuario.roles || !Array.isArray(userParams.Usuario.roles)) {
        return false;
    }
    const rolesStr = userParams.Usuario.roles.join(',');
    const payload = {
        id_permiso,
        roles: rolesStr
    };
    try {
        const res = await instance.post('/security/permisos', payload, {
            headers: {
                'Authorization': 'Bearer ' + auth.token,
                'Content-Type': 'application/json'
            }
        });
        // Espera respuesta tipo { response: { exists: boolean } }
        if (res.data?.response?.exists === true) {
            return true;
        }
        return false;
    } catch (e) {
        return false;
    }
}
export default {
	getDatosUsuario,
    checkPermiso
};